export const defaultMateriales = [
  { id: 'mat1', codigo: 'MAT-001', descripcion: 'Tornillo M8', stockActual: 1000 },
  { id: 'mat2', codigo: 'MAT-002', descripcion: 'Tuerca M8', stockActual: 1200 },
  { id: 'mat3', codigo: 'MAT-003', descripcion: 'Placa de Acero 10x10', stockActual: 50 },
  { id: 'mat4', codigo: 'MAT-004', descripcion: 'Cable Eléctrico 2m', stockActual: 200 },
  { id: 'mat5', codigo: 'MAT-005', descripcion: 'Sensor de Temperatura', stockActual: 10 },
  { id: 'mat6', codigo: 'MAT-006', descripcion: 'Resistencia 100 Ohm', stockActual: 500 },
  { id: 'mat7', codigo: 'MAT-007', descripcion: 'Motor Pequeño', stockActual: 5 },
  { id: 'mat8', codigo: 'MAT-008', descripcion: 'Engranaje Plástico', stockActual: 300 },
  { id: 'mat9', codigo: 'MAT-009', descripcion: 'Batería Litio 3.7V', stockActual: 25 },
  { id: 'mat10', codigo: 'MAT-010', descripcion: 'LED Rojo 5mm', stockActual: 1500 },
  { id: 'mat11', codigo: 'MAT-011', descripcion: 'Carcasa Plástica Grande', stockActual: 70 },
  { id: 'mat12', codigo: 'MAT-012', descripcion: 'Ventilador 12V', stockActual: 15 },
  { id: 'mat13', codigo: 'MAT-013', descripcion: 'Disipador Aluminio', stockActual: 40 },
  { id: 'mat14', codigo: 'MAT-014', descripcion: 'Conector USB-C', stockActual: 800 },
  { id: 'mat15', codigo: 'MAT-015', descripcion: 'Interruptor ON/OFF', stockActual: 600 },
  { id: 'mat16', codigo: 'MAT-016', descripcion: 'Tubo PVC 1m', stockActual: 100 },
  { id: 'mat17', codigo: 'MAT-017', descripcion: 'Válvula de Paso', stockActual: 30 },
  { id: 'mat18', codigo: 'MAT-018', descripcion: 'Bomba de Agua Pequeña', stockActual: 8 },
  { id: 'mat19', codigo: 'MAT-019', descripcion: 'Filtro de Aire', stockActual: 20 },
  { id: 'mat20', codigo: 'MAT-020', descripcion: 'Rodamiento de Bolas', stockActual: 400 },
];